"use client";

import { createContext, useContext, useMemo } from "react";

const PublicCatalogContext = createContext(null);

export function PublicCatalogDataProvider({ value = null, children }) {
  const parent = useContext(PublicCatalogContext);
  const merged = useMemo(() => {
    if (value == null && parent == null) return null;
    return { ...(parent || {}), ...(value || {}) };
  }, [parent, value]);
  return <PublicCatalogContext.Provider value={merged}>{children}</PublicCatalogContext.Provider>;
}

export function usePublicCatalogData() {
  return useContext(PublicCatalogContext);
}
